module.exports = __webpack_public_path__ + "img/camping.e080f3ec.jpg";